var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewsletter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 17.84,
    height: 11.35,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 17.84,
    height: 11.35,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.02,
    y: 6,
    width: 17.79,
    height: 8.34,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4873"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2133",
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4868"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4838"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9076",
    d: "M20.84,16.19c0,.63-.51,1.14-1.14,1.14l-15.55,.02c-.63,0-1.13-.51-1.14-1.14V7.16c-.01-.63,.5-1.14,1.12-1.14l15.55-.02c.63,0,1.14,.51,1.14,1.13v9.06Z",
    style: {
      fill: "#ffc342"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9077",
    d: "M12.58,12.07c-.41-.24-.92-.24-1.33,0l-7.76,5.06c.19,.14,.42,.22,.66,.22l15.55-.02c.24,0,.47-.08,.66-.22l-7.78-5.04Z",
    style: {
      fill: "#ffce41"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4836",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4835"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9078",
    d: "M19.69,6l-15.55,.02c-.58,.02-1.05,.46-1.12,1.04l8.13,7.01c.45,.37,1.1,.37,1.55,0l8.11-7.03c-.07-.57-.54-1.01-1.12-1.04",
    style: {
      fill: "#898988"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9079",
    d: "M19.69,6l-15.55,.02c-.56,0-1.03,.41-1.12,.96l8.13,6.48c.46,.34,1.09,.34,1.55,0l8.11-6.5c-.09-.55-.56-.95-1.12-.95",
    style: {
      fill: "#ffce41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9080",
    d: "M10.05,10.39h0c.77-.27,1.62,.13,1.89,.91,.03,.07,.04,.14,.06,.22,.16-.8,.93-1.33,1.74-1.17,.8,.16,1.33,.93,1.17,1.74-.02,.12-.06,.23-.11,.33-.08,.17-.2,.33-.34,.46l-2.49,2.33v.02h0s0,0,0,0v-.02l-2.45-2.38c-.12-.11-.21-.23-.29-.37-.37-.73-.07-1.62,.66-1.99,.06-.03,.11-.05,.17-.07",
    style: {
      fill: "#e02829"
    }
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/newsletter.a3bb5b59120b1a3abf583a8857972dde.svg";
export { ForwardRef as ReactComponent };